module.exports = __webpack_public_path__ + "static/media/3.649b21b4.jpg";